export const AUCTION_MODULE_PDP = 'auctionModuleDlosPDP';
export const AUCTION_SIDERAIL_REDESIGN = 'AuctionPDPSiderail';
export const DISABLE_TOP_YMAL_PDP = 'disableTopYmalPdp';
export const PDP_LIVE_CHAT = 'pdp-live-chat';
export const ENHANCED_BUYER_INCENTIVES = 'enhancedBuyerIncentives';
